import { Controller } from "@hotwired/stimulus"

// Affiche le nom du fichier sélectionné à côté d'un <input type="file"> masqué.
export default class extends Controller {
  static targets = ["input", "name"]

  show() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (file && this.hasNameTarget) this.nameTarget.textContent = file.name
  }
}
